import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { notification } from "antd";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";


// const BASE_URL = "https://tcs.teamexbiz.in/api/api";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const loginUser = async ({ email, password }) => {
  const response = await axios.post(
    `${BASE_URL}/auth/login`,
    { email, password },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};

export const useLoginMutation = () => {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: loginUser,
    onSuccess: (data) => {
      const token = data.token;
      localStorage.setItem("token", token);
      localStorage.setItem("firstName", data.user.firstName);
      localStorage.setItem("lastName", data.user.lastName);
      localStorage.setItem("gender", data.user.gender);
      localStorage.setItem("isLogin", "true");

      try {
        const decoded = jwtDecode(token);
        if (decoded.exp) {
          const expiryTime = decoded.exp * 1000 - Date.now(); 
          setTimeout(() => {
            localStorage.clear();
            notification.warning({
              message: "Session expired. Please log in again.",
            });
            navigate("/login");
          }, expiryTime);
        }
      } catch (err) {
        // console.error("Invalid token:", err);
      }

      notification.success({ message: "Login Successful" });
      navigate("/chats");
    },

    onError: (error) => {
      notification.error({
        message: "Invalid credentials",
        description: error?.response?.data?.message || "Login failed",
      });
    },
  });
};
